import React from "react";
import PropTypes from "prop-types";
import AppUtils from "@src/utils/appUtils";
import { useIsMobileWidth, useIsTabletWidth } from "@src/utils/mediaQuery";
import VerticalLayout from "./VerticalLayout";
import HorizontalLayout from "./HorizontalLayout";

/** For two child components, normally Horizontally-split, BUT swaps to Vertical in Mobile.
 * (For Horizontal everywhere, use HorizontalLayout instead)
 *
 * @param {object} props
 * @param {React.ReactNode} props.children
 * @param {number} [props.gap=0]
 * @param {Partial<Record<keyof typeof horizontalLayoutControls, any>>} [props.horizontal] - HorizontalLayout props
 * @param {Partial<Record<keyof typeof verticalLayoutControls, any>>} [props.vertical] - VerticalLayout props
 * @param {"mobile"|"tablet"} [props.breakpoint] - At which width should vertical layout be used
 */
const HorizontalResponsiveLayout = ({
  children,
  gap = 0,
  horizontal = {
    ratio: [1, 2],
    px: 4,
    py: 4,
    className: "",
  },
  vertical = {
    //title: "",
    //footerImage: "",
    //footerLink: "",
    //layoutType: "",
    //className: "",
  },
  breakpoint = "mobile",
}) => {
  const isMobile = useIsMobileWidth();
  const isTablet = useIsTabletWidth();
  const isBelowThreshold = breakpoint === "mobile" ? isMobile : isTablet;
  if (isBelowThreshold) {
    return (
      <VerticalLayout {...{ ...vertical, gap }}>{children}</VerticalLayout>
    );
  } else {
    return (
      <HorizontalLayout {...{ ...horizontal, gap }}>
        {children}
      </HorizontalLayout>
    );
  }
};

export const horizontalResponsiveLayoutControls = {
  children: {
    propType: PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.element,
      PropTypes.string,
    ]),
    description: "Content",
    disable: true,
  },
  horizontal: {
    propType: PropTypes.object.isRequired,
    description: "Props for HorizontalLayout when NOT in Mobile",
  },
  vertical: {
    propType: PropTypes.object.isRequired,
    description: "Props for VerticalLayout when in Mobile",
  },
};

HorizontalResponsiveLayout.propTypes = AppUtils.getPropTypeFromControls(
  horizontalResponsiveLayoutControls,
);

export default HorizontalResponsiveLayout;
